var infraestructuras = angular.module('chatbox');

infraestructuras.factory(
    'chatboxService',
    [
        '$http',
        '__env',
        function ($http, __env) {

            var apiBaseUrl = (__env.apiUrl || '').replace(/\/+$/, '');
            var chatboxUrl = apiBaseUrl + '/chatbox';

            function createConversation() {
                return $http({
                    method: 'POST',
                    url: chatboxUrl + '/conversation'
                });
            }

            function sendInspectorVirtualMessage(message, conversationId) {
                return $http({
                    method: 'POST',
                    url: chatboxUrl + '/mensajeIV',
                    data: {
                        request: message,
                        conversationId: conversationId
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }

            function sendInspectorForalMessage(message, conversationId) {
                return $http({
                    method: 'POST',
                    url: chatboxUrl + '/mensajeIF',
                    data: {
                        request: message,
                        conversationId: conversationId
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }

            function sendTrianoMessage(message, conversationId) {
                return $http({
                    method: 'POST',
                    url: chatboxUrl + '/mensaje',
                    data: {
                        request: message,
                        conversationId: conversationId
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }

            function getThread() {
                return createConversation();
            }

            function getChatBoxThread(message, conversationId) {
                return sendInspectorVirtualMessage(
                    //return sendInspectorForalMessage(
                    message,
                    conversationId
                );
            }

            return {
                createConversation: createConversation,
                sendInspectorVirtualMessage: sendInspectorVirtualMessage,
                sendTrianoMessage: sendTrianoMessage,
                sendInspectorForalMessage: sendInspectorForalMessage,
                getThread: getThread,
                getChatBoxThread: getChatBoxThread
            };
        }
    ]
);